import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';


const CardConsultCancelDetailUX = (props: any) => {
    return(
      <div>
        <div
          id="CardConsultCancelDetailUX-div-1"
          style={{ display: "flex", paddingBottom: "20px" }}>
          
          <div
            id="CardConsultCancelDetailUX-div-3"
            style={{ fontWeight: "bold", paddingRight: "5px" }}>
            ยกเลิกนัดหมาย Consult โดย  
          </div>
          <div
            id="CardConsultCancelDetailUX-div-5">
            {props.cancel_note || ""}
          </div>
        </div>
        <div
          id="CardConsultCancelDetailUX-div-1"
          style={{ display: "flex", paddingBottom: "20px" }}>
          
          <div
            id="CardConsultCancelDetailUX-div-8"
            style={{ fontWeight: "bold", paddingRight: "5px" }}>
            กรุณาระบุเหตุผลในการยกเลิก
          </div>
          <div
            id="CardConsultCancelDetailUX-div-9">
            {props.cancel_reason || ""}
          </div>
        </div>
        <div
          id="CardConsultCancelDetailUX-div-2"
          style={{ display: "flex", paddingBottom: "20px" }}>
          
          <div
            id="CardConsultCancelDetailUX-div-4"
            style={{ fontWeight: "bold", paddingRight: "5px" }}>
            ยกเลิก โดย  
          </div>
          <div
            id="CardConsultCancelDetailUX-div-6">
            {props.cancel_user || ""}
          </div>
        </div>
      </div>
    )
}


export default CardConsultCancelDetailUX

export const screenPropsDefault = {}

/* Date Time : Wed Jul 16 2025 11:07:01 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardConsultCancelDetailUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"20px\" }"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardConsultCancelDetailUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"20px\" }"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "ยกเลิกนัดหมาย Consult โดย  "
        },
        "id": {
          "type": "value",
          "value": "CardConsultCancelDetailUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", paddingRight: \"5px\" }"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": "ยกเลิก โดย  "
        },
        "id": {
          "type": "value",
          "value": "CardConsultCancelDetailUX-div-4"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", paddingRight: \"5px\" }"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 5,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "code",
          "value": "props.cancel_note || \"\""
        },
        "id": {
          "type": "value",
          "value": "CardConsultCancelDetailUX-div-5"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": null,
      "id": 6,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "code",
          "value": "props.cancel_user || \"\""
        },
        "id": {
          "type": "value",
          "value": "CardConsultCancelDetailUX-div-6"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 7,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardConsultCancelDetailUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"20px\" }"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 8,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "value",
          "value": "กรุณาระบุเหตุผลในการยกเลิก"
        },
        "id": {
          "type": "value",
          "value": "CardConsultCancelDetailUX-div-8"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", paddingRight: \"5px\" }"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": null,
      "id": 9,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "code",
          "value": "props.cancel_reason || \"\""
        },
        "id": {
          "type": "value",
          "value": "CardConsultCancelDetailUX-div-9"
        }
      },
      "seq": 9,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "name": "CardConsultCancelDetailUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
